module.exports = __webpack_public_path__ + "static/img/full_page_browser_img.e891169.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/full_page_browser_img.svg
// module id = L1Mb
// module chunks = 1